import { pushToDataLayer } from './GoogleTagManager';

enum EventCategory {
  JobsFeed = 'JobsFeed',
}

interface IGTMEvent {
  category: EventCategory;
  action: string;
  label?: string;
  pageTitle?: string;
}

export class GTMEvents {
  private static registerPageViewEvent(pageViewEvent: IGTMEvent) {
    pushToDataLayer({ ...pageViewEvent, event: 'pageView', action: `${pageViewEvent.action} is loaded` });
  }

  public static jobsFeed = {
    pageViews: {
      register(action: string, pageTitle = 'App') {
        GTMEvents.registerPageViewEvent({ action, pageTitle, category: EventCategory.JobsFeed });
      },
      matchingMyFilters(pageTitle: string) {
        this.register('Jobs feed — Matching my filters', pageTitle);
      },
      projects(pageTitle: string) {
        this.register('Jobs feed — Projects', pageTitle);
      },
      allOpportunities(pageTitle: string) {
        this.register('Jobs feed — All opportunities', pageTitle);
      },
      allPaid(pageTitle: string) {
        this.register('Jobs feed — All paid', pageTitle);
      },
      breakdown(pageTitle: string) {
        this.register('Jobs feed — Breakdown', pageTitle);
      },
      followUp(pageTitle: string) {
        this.register('Jobs feed — Follow-up', pageTitle);
      },
      role(pageTitle: string) {
        this.register('Jobs feed — Role', pageTitle);
      },
      agentQuickSearch(pageTitle: string) {
        this.register('Jobs feed — Agent quick search', pageTitle);
      },
    },
  };
}
